import {Employee} from "../../api/Model";
import React, {useCallback, useState} from "react";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {EmployeeSelect} from "../employee-select/EmployeeSelect";
import {NeighbourhoodGuessResultPane} from "./NeighbourhoodGuessResultPane";
import {useEmployeeNeighbourhoodStore} from "../../api/EmployeeNeighbourhoodStore";

export function GuessNeighbourhoodDialog({open, onClose}: {
    open: boolean;
    onClose: () => void;
}) {
    const employeeNeighbourhoods = useEmployeeNeighbourhoodStore(state => state.remoteValue);
    const [employee, setEmployee] = useState<Employee | undefined>(undefined);

    const handleClose = useCallback(() => {
        setEmployee(undefined);
        onClose();
    }, [setEmployee, onClose]);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Neighbourhood Guesser</DialogTitle>
            <DialogContent>
                <EmployeeSelect
                    employee={employee}
                    setEmployee={setEmployee}
                    label="Employee"
                    variant="outlined"
                    sx={{my: 2}}
                    fullWidth
                />

                {employee ? (
                    <NeighbourhoodGuessResultPane employee={employee} employeeNeighbourhoods={employeeNeighbourhoods}/>
                ) : (
                    <Alert severity="info" sx={{mt: 2, mb: 2}}>
                        Select an employee to guess their neighbourhood
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}